import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";
import { RiListCheck3 } from "react-icons/ri";
import { TbTruckDelivery } from "react-icons/tb";
import { PiHandArrowDownDuotone } from "react-icons/pi";
import { FaRegEye } from "react-icons/fa";
import { MdOutlineCommentsDisabled } from "react-icons/md";
import { MdOutlineComment } from "react-icons/md";

//Srcs
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import UpdateReqPurchase from "./UpdateReqPurchase";
import CheckReqPurchase from "./CheckReqPurchase";
import ReviewReqPurchase from "./ReviewReqPurchase";
import CreatePurchase from "./CreatePurchase";
import RecievePurchase from "./RecievePurchase";
import VoidRequest from "./VoidRequest";

export default function ReqPurchaseAction({ setRefetch, editData }) {
  // console.log("edeitef", editData);
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal check
  const [openCheck, setOpenCheck] = useState(false);
  const handleOpenCheck = () => setOpenCheck(true);
  const handleCloseCheck = () => setOpenCheck(false);

  //Modal delivery
  const [openDelivery, setOpenDelivery] = useState(false);
  const handleOpenDelivery = () => setOpenDelivery(true);
  const handleCloseDelivery = () => setOpenDelivery(false);
  //Modal recieve
  const [openRecieve, setOpenRecieve] = useState(false);
  const handleOpenRecieve = () => setOpenRecieve(true);
  const handleCloseRecieve = () => setOpenRecieve(false);
  //Modal view
  const [openViews, setOpenViews] = useState(false);
  const handleOpenViews = () => setOpenViews(true);
  const handleCloseViews = () => setOpenViews(false);
  //Modal void
  const [openVoid, setOpenVoid] = useState(false);
  const handleOpenVoid = () => setOpenVoid(true);
  const handleCloseVoid = () => setOpenVoid(false);

  //Modal reset
  const [openReset, setOpenReset] = useState(false);
  const handleOpenReset = () => setOpenReset(true);
  const handleCloseReset = () => setOpenReset(false);
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {editData?.voidBy === null ? (
          editData?.status === "Approved" ? (
            <Tooltip title="ដឹកជញ្ជូន" placement="top">
              <IconButton onClick={handleOpenDelivery}>
                <Box className="apprv-container">
                  <TbTruckDelivery className="apprv-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          ) : editData?.status === "Purchase" ? (
            <Tooltip title="ទទួល" placement="top">
              <IconButton onClick={handleOpenRecieve}>
                <Box className="deliver-container">
                  <PiHandArrowDownDuotone className="deliver-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          ) : editData?.status === "Received" ||
            editData?.status === "Rejected" ||
            editData?.status === "InStock" ? (
            <Tooltip title="មើលទិន្នន័យ" placement="top">
              <IconButton onClick={handleOpenViews}>
                <Box className="update-container">
                  <FaRegEye className="update-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="ពិនិត្យ" placement="top">
              <IconButton onClick={handleOpenCheck}>
                <Box className="check-container">
                  <RiListCheck3 className="check-icon" />
                </Box>
              </IconButton>
            </Tooltip>
          )
        ) : (
          <Tooltip title="មើលទិន្នន័យ" placement="top">
            <IconButton onClick={handleOpenViews}>
              <Box className="update-container">
                <FaRegEye className="update-icon" />
              </Box>
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
            onClick={handleOpenEdit}
            disabled={editData?.status !== "Pending"}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="ធ្វើមោឃៈ" placement="top">
          <IconButton
            onClick={handleOpenVoid}
            disabled={
              editData?.voidBy !== null || editData?.status === "Rejected"
            }
          >
            <Box className="delete-container">
              {editData?.voidBy === null ? (
                <MdOutlineComment className="delete-icon" />
              ) : (
                <MdOutlineCommentsDisabled className="delete-icon" />
              )}
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <UpdateReqPurchase
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />

      <CheckReqPurchase
        open={openCheck}
        handleClose={handleCloseCheck}
        editData={editData}
        setRefetch={setRefetch}
      />
      <CreatePurchase
        open={openDelivery}
        handleClose={handleCloseDelivery}
        editData={editData}
        setRefetch={setRefetch}
      />
      <RecievePurchase
        open={openRecieve}
        handleClose={handleCloseRecieve}
        editData={editData}
        setRefetch={setRefetch}
      />
      <ReviewReqPurchase
        open={openViews}
        handleClose={handleCloseViews}
        editData={editData}
        setRefetch={setRefetch}
      />
      <VoidRequest
        open={openVoid}
        handleClose={handleCloseVoid}
        editData={editData}
        setRefetch={setRefetch}
      />

      {/* <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"អ្នកផ្គត់ផ្គង"}
        loading={loading}
        handleDelete={handleDelete}
      /> */}
    </div>
  );
}
